module.exports = __webpack_public_path__ + "img/PASTE.c87c8c15.svg";